import pageSerializer from '@/api/serializer/page'
import { IGetPageRes } from '../interfaces/response'
import { IInitState, Page } from '../interfaces/types'

export const PAGES: Record<Page, (page: IGetPageRes) => IInitState> = {
  HomePage: pageSerializer,
  TariffPage: pageSerializer,
  TaskPage: pageSerializer,
  SportsmanSchedulePage: pageSerializer,
  TariffListPage: pageSerializer,
  CreateTaskPage: pageSerializer,
  StatisticsPage: pageSerializer,
  CreateCertificatePage: pageSerializer,
  CertificatePage: pageSerializer,
  ContractPage: pageSerializer,
  FlyListPage: pageSerializer
}
